import { Col, Row } from "antd";
import React from "react";
import BottomFooter from "./BottomFooter";
import TopFooter from "./TopFooter";

export default function Footer() {
  return (
    <Row gutter={[24, 24]}>
      <Col xs={24} className="section">
        <TopFooter />
      </Col>
      <Col style={{ borderTop: "1px solid #ddd" }} xs={24}>
        <BottomFooter />
      </Col>
    </Row>
  );
}
